var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 70,
    viewBox: "0 0 87 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#7952b3",
      fillOpacity: 1
    },
    d: "M18.07.008c-4.965 0-8.636 4.387-8.472 9.144.156 4.575-.047 10.493-1.524 15.32-1.48 4.844-3.984 7.91-8.074 8.305v4.446c4.09.394 6.594 3.46 8.074 8.304 1.477 4.828 1.68 10.746 1.524 15.32-.164 4.758 3.507 9.145 8.472 9.145h50.867c4.965 0 8.637-4.387 8.473-9.144-.16-4.575.047-10.493 1.524-15.32 1.48-4.844 3.976-7.91 8.066-8.305v-4.446c-4.09-.394-6.586-3.46-8.066-8.304-1.477-4.828-1.684-10.746-1.524-15.32.164-4.758-3.508-9.145-8.472-9.145Zm40.914 43.078c0 6.555-4.84 10.527-12.87 10.527H32.44a1.483 1.483 0 0 1-1.476-1.488v-34.25c0-.82.66-1.488 1.476-1.488h13.594c6.695 0 11.09 3.664 11.09 9.289 0 3.945-2.957 7.48-6.723 8.097v.207c5.13.567 8.582 4.153 8.582 9.106ZM44.621 21.109h-7.797v11.118h6.567c5.078 0 7.875-2.063 7.875-5.754 0-3.457-2.407-5.364-6.645-5.364Zm-7.797 15.528V48.89h8.086c5.281 0 8.082-2.141 8.082-6.164 0-4.024-2.879-6.09-8.422-6.09Zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.1c45b8a391b1fb525f60d91a203dc0cd.svg";
export { ForwardRef as ReactComponent };